import React from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard({ user, setUser }) {
  const navigate = useNavigate();

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setUser({ ...user, avatar: e.target.result });
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <header>
        <img
          src={user.avatar || "https://via.placeholder.com/50"}
          alt="Avatar"
          style={{ borderRadius: '50%', width: '50px', height: '50px' }}
        />
        <span>{user.name}</span>
      </header>
      <h1>Dashboard</h1>
      <input type="file" onChange={handleAvatarChange} />
      <button onClick={() => navigate('/home')}>Go to Home</button>
    </div>
  );
}

export default Dashboard;
